// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-content-js": () => import("/opt/build/repo/labs/src/templates/content.js" /* webpackChunkName: "component---src-templates-content-js" */),
  "component---src-pages-404-js": () => import("/opt/build/repo/labs/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/labs/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/build/repo/labs/.cache/data.json")

